import axios from 'axios';
import { API } from './constants';

let refreshInFlight = null;

// Recipe routes can mount before an access token has been restored from the
// refresh token. Coordinate that bootstrap so concurrent page effects share a
// single refresh and protected recipe requests never race ahead anonymously.
export async function getAuthConfig() {
  const accessToken = localStorage.getItem('adminToken');
  if (accessToken) {
    return { headers: { Authorization: `Bearer ${accessToken}` } };
  }

  const refreshToken = localStorage.getItem('refreshToken');
  if (!refreshToken) return undefined;

  if (!refreshInFlight) {
    refreshInFlight = axios.post(`${API}/refresh`, { refresh_token: refreshToken })
      .then((response) => {
        const token = response.data?.token;
        if (!token) throw new Error('Refresh response did not include an access token');
        localStorage.setItem('adminToken', token);
        if (response.data.refresh_token) {
          localStorage.setItem('refreshToken', response.data.refresh_token);
        }
        return token;
      })
      .finally(() => {
        refreshInFlight = null;
      });
  }

  try {
    const token = await refreshInFlight;
    return { headers: { Authorization: `Bearer ${token}` } };
  } catch {
    return undefined;
  }
}